import utilitiesMap from "../../lib/utilities-map";

const RECCalc = (
  panelAmount,
  mod,
  invRating,
  annualProduction,
  state,
  loanName,
  hasRec,
  utility
) => {
  const calculateMultiplier = (annualProduction) => {
    const efficiencies = [
      98.5, 97.8105, 97.1258265, 96.44594571, 95.77082409, 95.10042833, 94.43472533, 93.77368225, 93.11726647, 92.46544561, 91.81818749, 91.17546018,
      90.53723196, 89.90347133, 89.27414703
    ];

    // This is the srec calculations.

    let totalResult = 0;

    // Calculate the result for each year and log it
    efficiencies.forEach((efficiency, index) => {
      // Multiply the annual production by the current efficiency
      const yearResult = (annualProduction * efficiency) / 100;
      // Add the year result to the total
      totalResult += yearResult;
    });

    return totalResult;
  };

  // Illinois calculations
  const result = calculateMultiplier(annualProduction / 1000) / 15;
  let wattSystem = mod[3] * panelAmount;

  let dcSystem = (mod[3] * panelAmount) / 1000;
  let acSystem = (panelAmount * ((mod[4] * invRating) / 1000)).toFixed(2);

  let capacityFactor = (result * 1000) / (acSystem * 8760);
  let numRecs = Math.floor(((acSystem * 8760) / 1000) * capacityFactor * 15);
  let acDcRatio = (dcSystem / acSystem).toFixed(2);
  let collateralRequired = (capacityFactor - (acDcRatio - 1.2) / 10) * 2.5;
  let recsPerYear = numRecs / 15;

  let recPrice = acSystem > 10 ? 79.21 : 80.77;
  //add $20 to the rec price because no itc
  if (new Date() >= new Date(2026, 5, 1)) recPrice += 20;
  //preserve old pricing for deals in the past
  if (new Date() < new Date(2026, 3, 22)) recPrice = acSystem > 10 ? 69.78 : 75.48;
  
  let totalPreBonds = recPrice * numRecs;

  let bond = totalPreBonds * 0.05;
  let collateralByCsg = totalPreBonds * 0.025;
  let csgFee = totalPreBonds * 0.15;
  let appFee = acSystem * 20;

  let afterEnergy = totalPreBonds - csgFee - appFee;
  let maxFinalBond = bond;
  let totalPostFees = totalPreBonds - csgFee - bond - collateralByCsg;
  let totalPostFeesAndBonds = totalPostFees + maxFinalBond + collateralByCsg;

  let recProduct = "Upfront";

  if ((state === "Virginia" || state === "Ohio") && +hasRec === 0) {
    recProduct = "Market";
  }

  let recValFinal = {
    afterEnergy: 0,
    capacityFactor: 0,
    numRecs: 0,
    acSystem: 0,
    additionalCollateral: 0,
    utilityCollateral: 0,
    applicationFee: 0,
    grossValue: 0,
    product: recProduct,
  };
  if (state === "Virginia" && +hasRec === 1) {
    recValFinal = {
      afterEnergy: wattSystem * 0.165,
      capacityFactor: 0,
      numRecs: 0,
      acSystem: acSystem,
      additionalCollateral: 0,
      utilityCollateral: 0,
      applicationFee: 0,
      grossValue: 0,
      product: recProduct,
    };
  }
  if (state === "Ohio" && +hasRec === 1) {
    recValFinal = {
      afterEnergy: wattSystem * 0.105,
      capacityFactor: 0,
      numRecs: 0,
      acSystem: acSystem,
      additionalCollateral: 0,
      utilityCollateral: 0,
      applicationFee: 0,
      grossValue: 0,
      product: recProduct,
    };
  }

  if (state === "Illinois") {
    const today = new Date();
    const april2025 = new Date(2025, 3, 1);
    const isBeforeApril2025 = today < april2025; // SREC 20% off before April '25

    if (false) {
      // Leaving in so we can turn it on for the next time they want it.
      recValFinal = {
        afterEnergy: afterEnergy * 0.8,
        capacityFactor: capacityFactor,
        numRecs: numRecs,
        acSystem: acSystem,
        additionalCollateral: collateralByCsg * 0.8,
        utilityCollateral: bond * 0.8,
        applicationFee: appFee,
        grossValue: totalPreBonds * 0.8,
        product: recProduct,
      };
    } else {
      recValFinal = {
        afterEnergy: afterEnergy,
        capacityFactor: capacityFactor,
        numRecs: numRecs,
        acSystem: acSystem,
        additionalCollateral: collateralByCsg,
        utilityCollateral: bond,
        applicationFee: appFee,
        grossValue: totalPreBonds,
        product: recProduct,
      };
    }

    // Solar Installation Rabate for Naperville Utility
    if (utilitiesMap["Naperville Utility"] === utility) {
      const rebateTotal = Math.round((wattSystem / 1000) * 250);

      recValFinal.afterEnergy += rebateTotal < 1750 ? rebateTotal : 1750;
    }
  }
  if (loanName === "LightReach PPA") {
    recValFinal = {
      afterEnergy: 0,
      capacityFactor: 0,
      numRecs: 0,
      acSystem: 0,
      additionalCollateral: 0,
      utilityCollateral: 0,
      applicationFee: 0,
      grossValue: 0,
      product: recProduct,
    };
  }

  // non refundable $20/kw AC
  // utility held collateral 5% off of net

  // console.log("Final Result:", result)
  // console.log("App Fee:", appFee)
  // console.log("capacityFactor", capacityFactor)
  // console.log("numRecs", numRecs)
  // console.log("dcSystem", dcSystem)
  // console.log("acDcRatio", acDcRatio)
  // console.log("collateralRequired", collateralRequired)
  // console.log("recsPerYear", recsPerYear)
  // console.log("recPrice", recPrice)
  // console.log("totalPreBonds", totalPreBonds)
  // console.log("bond", bond)
  // console.log("collateralByCsg", collateralByCsg)
  // console.log("csgFee", csgFee)
  // console.log("afterEnergy", afterEnergy)
  // console.log("maxFinalBond", maxFinalBond)
  // console.log("totalPostFees", totalPostFees)
  // console.log("totalPostFeesAndBonds", totalPostFeesAndBonds)

  return recValFinal;
};
export default RECCalc;
